// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-container {
    max-width: 1100px;
    margin: auto;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    font-size: 12px;
}

th, td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
    text-align: center;
}

th {
    background-color: #305e7a;
    color: white;
}

.reports-table th:nth-child(7),
.reports-table td:nth-child(7) {
    min-width: 100px; /* Adjust width as needed */
    text-align: center; /* Keep text readable */
}

.reports-table th:nth-child(8),
.reports-table td:nth-child(8) {
    min-width: 60px; /* Adjust width as needed */
    text-align: center; /* Keep text readable */
}
.filters {
    display: flex;
    align-items: center;
    gap: 15px; /* Adjust spacing between elements */
    
}

.filters label {
    
    font-size: 15px;
    color: #333;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    
}

.date-filters {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 150px;
    
}

.robot-filter {
    display: flex ;
    flex-direction: column;
    
}

.buttons {
    display: flex;
    gap: 10px; /* Reduce spacing between buttons */
    justify-content: center; /* Center the buttons */
    flex-wrap: wrap; /* Allow buttons to wrap on smaller screens */
}

.buttons button {
    width: auto; /* Let the button size adjust based on content */
    min-width: 100px; /* Ensure a minimum width for smaller buttons */
    padding: 8px 12px; /* Reduce padding for a smaller appearance */
    font-size: 14px; /* Reduce font size */
    border-radius: 5px; /* Optional: Make buttons slightly rounded */
    transition: all 0.2s ease-in-out; /* Smooth transition effect */
}

/* Make buttons fully responsive for smaller screens */
@media (max-width: 600px) {
    .buttons {
        flex-direction: column; /* Stack buttons vertically on small screens */
        align-items: center; /* Center align the buttons */
    }

    .buttons button {
        width: 90%; /* Make buttons take most of the width on small screens */
    }
}

/* Add these new styles */
.pagination-info {
    font-size: 0.9rem;
    color: #666;
    margin: 10px 0;
}

.pagination-controls {
    font-size: 0.85rem;
    margin: 15px 0;
}

.pagination-controls button {
    padding: 4px 12px;
    font-size: 0.85rem;
    margin: 0 5px;
}

.pagination-controls span {
    margin: 0 10px;
    color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Reports.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,gBAAgB,EAAE,2BAA2B;IAC7C,kBAAkB,EAAE,uBAAuB;AAC/C;;AAEA;;IAEI,eAAe,EAAE,2BAA2B;IAC5C,kBAAkB,EAAE,uBAAuB;AAC/C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,oCAAoC;;AAEnD;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;;AAEhB;;AAEA;IACI,cAAc;IACd,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,SAAS,EAAE,mCAAmC;IAC9C,uBAAuB,EAAE,uBAAuB;IAChD,eAAe,EAAE,6CAA6C;AAClE;;AAEA;IACI,WAAW,EAAE,gDAAgD;IAC7D,gBAAgB,EAAE,+CAA+C;IACjE,iBAAiB,EAAE,4CAA4C;IAC/D,eAAe,EAAE,qBAAqB;IACtC,kBAAkB,EAAE,4CAA4C;IAChE,gCAAgC,EAAE,6BAA6B;AACnE;;AAEA,sDAAsD;AACtD;IACI;QACI,sBAAsB,EAAE,8CAA8C;QACtE,mBAAmB,EAAE,6BAA6B;IACtD;;IAEA;QACI,UAAU,EAAE,yDAAyD;IACzE;AACJ;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;AACf","sourcesContent":[".reports-container {\n    max-width: 1100px;\n    margin: auto;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n    font-size: 12px;\n}\n\nth, td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: left;\n    text-align: center;\n}\n\nth {\n    background-color: #305e7a;\n    color: white;\n}\n\n.reports-table th:nth-child(7),\n.reports-table td:nth-child(7) {\n    min-width: 100px; /* Adjust width as needed */\n    text-align: center; /* Keep text readable */\n}\n\n.reports-table th:nth-child(8),\n.reports-table td:nth-child(8) {\n    min-width: 60px; /* Adjust width as needed */\n    text-align: center; /* Keep text readable */\n}\n.filters {\n    display: flex;\n    align-items: center;\n    gap: 15px; /* Adjust spacing between elements */\n    \n}\n\n.filters label {\n    \n    font-size: 15px;\n    color: #333;\n    display: flex;\n    flex-direction: column;\n    padding-top: 10px;\n    \n}\n\n.date-filters {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: 150px;\n    \n}\n\n.robot-filter {\n    display: flex ;\n    flex-direction: column;\n    \n}\n\n.buttons {\n    display: flex;\n    gap: 10px; /* Reduce spacing between buttons */\n    justify-content: center; /* Center the buttons */\n    flex-wrap: wrap; /* Allow buttons to wrap on smaller screens */\n}\n\n.buttons button {\n    width: auto; /* Let the button size adjust based on content */\n    min-width: 100px; /* Ensure a minimum width for smaller buttons */\n    padding: 8px 12px; /* Reduce padding for a smaller appearance */\n    font-size: 14px; /* Reduce font size */\n    border-radius: 5px; /* Optional: Make buttons slightly rounded */\n    transition: all 0.2s ease-in-out; /* Smooth transition effect */\n}\n\n/* Make buttons fully responsive for smaller screens */\n@media (max-width: 600px) {\n    .buttons {\n        flex-direction: column; /* Stack buttons vertically on small screens */\n        align-items: center; /* Center align the buttons */\n    }\n\n    .buttons button {\n        width: 90%; /* Make buttons take most of the width on small screens */\n    }\n}\n\n/* Add these new styles */\n.pagination-info {\n    font-size: 0.9rem;\n    color: #666;\n    margin: 10px 0;\n}\n\n.pagination-controls {\n    font-size: 0.85rem;\n    margin: 15px 0;\n}\n\n.pagination-controls button {\n    padding: 4px 12px;\n    font-size: 0.85rem;\n    margin: 0 5px;\n}\n\n.pagination-controls span {\n    margin: 0 10px;\n    color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
